module.exports = __webpack_public_path__ + "img/icon_yingjiankaifa.0bbb3ec1.png";